module.exports = __webpack_public_path__ + "media/images/flags/li-746cbfcac47eede5533a5b5ae9ad93bb.svg";